import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import EstoqueModel from "@/models/estoqueModel";
import estoqueService from "@/services/estoqueService";

import ListComponentBase from "../listComponentBase";

import "../crud.scss";

@Component
export default class EstoqueListComponent extends ListComponentBase<EstoqueModel> {
    // State computed props

    get gridColumns(): Array<GridColumn> {
        return [new GridColumn("descricao", this.$t("__.ts.descricao"), GridColumnType.String)];
    }

    private beforeMount() {
        this.setPropsCached(estoqueService, "estoque", "descricao");
    }
}
